import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";

import { CircleAIDockCommunityHeaderCollapsed } from "./CircleAIDockCommunityHeaderCollapsed";
import { CircleAIDockCommunityHeaderExpanded } from "./CircleAIDockCommunityHeaderExpanded";

export const CircleAIDockCommunityHeader = () => {
  const isCollapsed = useCircleAIShellStore(s => s.dockMode === "collapsed");

  return isCollapsed ? (
    <CircleAIDockCommunityHeaderCollapsed />
  ) : (
    <CircleAIDockCommunityHeaderExpanded />
  );
};
